<template>
  <div>
    <header>
      <h1 class="title">HundredTrees Compensation Log</h1>
    </header>
    <!-- CompensatedData shows de compensation details after submitting the form -->
    <CompensatedData
      :compensatedData="compensatedData"
      v-if="showCompensated"
    />

    <CompensationForm :showCompensatedData="showCompensatedData" />

    <!-- History Compensations -->
    <CompensatedData
      v-for="compensation in historyCompensations"
      :compensatedData="compensation"
      :key="compensation.id"
    />
  </div>
</template>

<script>
import axios from "axios";
import CompensationForm from "./components/CompensationForm.vue";
import CompensatedData from "./components/CompensatedData.vue";

export default {
  name: "App",
  components: {
    CompensationForm,
    CompensatedData,
  },
  data: function () {
    return {
      // Our already made compensations
      historyCompensations: [],
      //object to pass as props to compensatedData component
      compensatedData: {
        title: "",
        compensated_at: "",
        proof_url: "",
        details_url: "",
        description: "",
        total_compensated_co2_kg: null,
      },
      showCompensated: false,
    };
  },
  mounted() {
    this.getActualCompensations();
  },
  methods: {
    //this function brings the recent compensation details from CompensationForm
    showCompensatedData(compensatedData) {
      this.compensatedData = { ...compensatedData };

      this.showCompensated = true;
    },
    async getActualCompensations() {
      try {
        const response = await axios.get(
          process.env.API_URL + "/internal/actual-compensations"
        );
        this.historyCompensations = response.data.compensations;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="css">
body {
  font-family: "Nunito", sans-serif;
}

.title {
  text-align: center;
}
</style>
